import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Style from './index.css';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel, Pagination, Keyboard } from 'swiper';
import Page1 from '@src/pc/index/layout/Page1';
import Page2 from '@src/pc/index/layout/Page2';
import Page3 from '@src/pc/index/layout/Page3';
import Page4 from '@src/pc/index/layout/Page4';
import Float from '@src/pc/index/layout/Float';
import VideoMask from '@src/common/components/VideoMask';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

const Layout = ({ content }) => {
    const { peopleList, leaderVideo, config } = content;
    const [swiperIndex, setSwiperIndex] = useState('1');
    const [maskVisible, setMaskVisible] = useState(false);
    const [currentVideo, setCurrentVideo] = useState({});
    const [isShowFloat, setIsShowFloat] = useState(false);

    const slides = config.filter((a) => a.isShow && a.id.match(/[0-9]/g));

    const [peopleIndex, setPeopleIndex] = useState(-1);

    useEffect(() => {
        // 设备宽度小于750跳到分享页
        if (window.screen.width < 750 && !window.location.href.includes('/visualediting')) {
            window.location.href = 'https://ishare.ifeng.com/c/s/8JgYnQDRLVo';
        }
    }, []);

    return (
        <div>
            <Chip id="260312" type="struct" name="peopleList" title="人物列表" groupName="人物列表">
                <div className={Style.chip} />
            </Chip>
            <Chip id="260389" type="struct" name="config" title="设置" groupName="设置">
                <div className={Style.chip} style={{ top: '40px' }} />
            </Chip>
            <Swiper
                className={Style.swiper}
                allowSlidePrev={!maskVisible}
                allowSlideNext={!maskVisible}
                direction="vertical"
                modules={[Scrollbar, Mousewheel, Pagination, Keyboard]}
                scrollbar={{
                    hide: true,
                }}
                simulateTouch={false}
                mousewheel={{
                    forceToAxis: true,
                }}
                speed={1500}
                keyboard={{
                    enabled: true,
                }}
                onSlideChange={(swiper) => {
                    setSwiperIndex(slides[swiper.realIndex].id);
                }}>
                {config.find((a) => a.id === '1').isShow && (
                    <SwiperSlide>
                        <Page1
                            config={config}
                            peopleList={peopleList}
                            leaderVideo={leaderVideo}
                            onChangeMaskVisible={setMaskVisible}
                            onChangeCurrentVideo={setCurrentVideo}
                            onChangeFloat={setIsShowFloat}
                            peopleIndex={peopleIndex}
                            onChangePeopleIndex={setPeopleIndex}
                        />
                    </SwiperSlide>
                )}
                {config.find((a) => a.id === '2').isShow && (
                    <SwiperSlide>
                        <Page2
                            peopleList={peopleList}
                            onChangeMaskVisible={setMaskVisible}
                            onChangeCurrentVideo={setCurrentVideo}
                            peopleIndex={peopleIndex === -1 ? 0 : peopleIndex}
                            onChangePeopleIndex={setPeopleIndex}
                        />
                    </SwiperSlide>
                )}
                {config.find((a) => a.id === '3').isShow && (
                    <SwiperSlide>
                        <Page3 peopleList={peopleList} peopleIndex={peopleIndex === -1 ? 0 : peopleIndex} onChangePeopleIndex={setPeopleIndex} />
                    </SwiperSlide>
                )}
                {config.find((a) => a.id === '4').isShow && (
                    <SwiperSlide>
                        <Page4 />
                    </SwiperSlide>
                )}
                {isShowFloat && (
                    <div className={Style.show}>
                        <Float slideIndex={swiperIndex} config={config} />
                    </div>
                )}
                <VideoMask visible={maskVisible} onChangeVisible={setMaskVisible} videoInfo={currentVideo} />
            </Swiper>
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
